import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';
import { AfterSignActionRoutes } from './afterSignActions';
import { DocumentTypeRoutes } from './documentTypes';
import { SignerRoleRoutes } from './signerRole';
import { TemplateRoutes } from './templates';
import { SigningPartyRoutes } from './signingParty';
import { SigningPartFieldRoutes } from './signingPartyField';
import { SigningPartyFieldPlacementRoutes } from './signingPartyFieldPlacement';

const ScriveAccountConfiguration = () =>
  import(
    /* webpackChunkName: "ScriveTemplateManagement" */
    '@/views/configuration/scrive/ScriveAccountConfiguration.vue'
  );

const ScriveSettings = () =>
  import(
    /* webpackChunkName: "ScriveSettings" */
    '@/views/configuration/scrive/ScriveSettings.vue'
  );

const layout = 'TreeView';

export const ScriveRoutes = [
  {
    ...Configuration.Scrive.AccountMangement.Base,
    components: {
      default: ScriveAccountConfiguration,
      treeView: ConfigurationTreeView
    },
    meta: {
      layout,
      treePath: 'scriveaccountconfiguration',
      treeViewKey: TreeViewConstants.Keys.Configuration,
      title: 'Scrive Account Configuration'
    }
  },
  {
    ...Configuration.Scrive.Settings.Base,
    components: {
      default: ScriveSettings,
      treeView: ConfigurationTreeView
    },
    meta: {
      layout,
      treePath: 'scrivesettings',
      treeViewKey: TreeViewConstants.Keys.Configuration,
      title: 'Scrive Settings'
    }
  },
  ...DocumentTypeRoutes,
  ...SignerRoleRoutes,
  ...TemplateRoutes,
  ...SigningPartyRoutes,
  ...SigningPartFieldRoutes,
  ...SigningPartyFieldPlacementRoutes,
  ...AfterSignActionRoutes
];
